module.exports = __webpack_public_path__ + "img/1543426398.749dcba6.jpg";